export default __webpack_public_path__ + "static/media/completed.6e8cc975.svg";